'use client';

import type { GetReviewsByActivityIdParams } from '@api/models';
import { useQuery } from '@tanstack/react-query';

import { type ReviewStatus, type ReviewsResult, getReviewsByActivityId } from '../services/reviews.service';

export interface UseReviewsParams extends Omit<GetReviewsByActivityIdParams, 'status'> {
  status?: ReviewStatus;
}

export const reviewsQueryKey = (activityId: string, params?: UseReviewsParams) =>
  ['reviews', activityId, params] as const;

export function useReviews(activityId: string, params?: UseReviewsParams) {
  return useQuery<ReviewsResult, Error>({
    queryKey: reviewsQueryKey(activityId, params),
    queryFn: () => getReviewsByActivityId(activityId, params),
    staleTime: 5 * 60 * 1000,
    enabled: !!activityId
  });
}
